'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isFunction2 = require('lodash/isFunction');

var _isFunction3 = _interopRequireDefault(_isFunction2);

var _isPlainObject2 = require('lodash/isPlainObject');

var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);

exports.default = handleActions;

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _handleAction = require('./handle-action.js');

var _handleAction2 = _interopRequireDefault(_handleAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function creacteReducers(createHandlers, defaultState) {
  var handlers = createHandlers();
  !(0, _isPlainObject3.default)(handlers) ? process.env.NODE_ENV !== 'production' ? (0, _invariant2.default)(false, 'createHandlers should return a plain object.') : (0, _invariant2.default)(false) : void 0;
  return Object.keys(handlers).map(function (type) {
    return (0, _handleAction2.default)(type, handlers[type], defaultState);
  });
}
function handleActions(createHandlers, defaultState, ns) {
  var reducers = void 0;
  !(0, _isFunction3.default)(createHandlers) ? process.env.NODE_ENV !== 'production' ? (0, _invariant2.default)(false, 'createHandlers should be a function') : (0, _invariant2.default)(false) : void 0;
  function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
    var action = arguments[1];

    if (!reducers) {
      reducers = creacteReducers(createHandlers, defaultState);
    }
    return reducers.reduce(function (state, reducer) {
      return reducer(state, action);
    }, state);
  }
  if (ns) {
    reducer.toString = function () {
      return ns;
    };
  }
  return reducer;
}


//////////////////
// WEBPACK FOOTER
// ./~/berkeleys-redux-utils/lib/handle-actions.js
// module id = 572
// module chunks = 168707334958949